import { useRef, useState } from "react";
import { apiRequest } from "../../../shared/api/client";
import type { ProductionReferenceData } from "../models";

export function useCounterDeviceWorkspace({lines}:{lines:ProductionReferenceData["lines"]}) {
const inFlight=useRef(false);
const [lineId, setLineId] = useState(lines[0]?.id ?? "");
const [deviceId, setDeviceId] = useState("");
const [unit, setUnit] = useState("KUTU");
const [saving, setSaving] = useState(false);
const [message, setMessage] = useState("");
const save = async () => {
    if (inFlight.current) return;
    inFlight.current = true;
    setSaving(true);
    setMessage("");
    try {
      const config = await apiRequest<unknown>(`/api/production/terminal/administration/counter-devices/${encodeURIComponent(deviceId.trim())}`, { method: "PUT", body: JSON.stringify({ lineId, unit, counterBits: 32 }) });
      const url = URL.createObjectURL(new Blob([JSON.stringify(config, null, 2)], { type: "application/json" }));
      const link = document.createElement("a");
      link.href = url; link.download = "server-upload.json"; link.click();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
      setMessage("Sunucu ayarı indirildi. Dosyayı okuyucu EXE'sinin yanına koyup okuyucuyu yeniden açın. Anahtarı paylaşmayın; yeniden oluşturmak eski anahtarı iptal eder.");
    } catch (error) { setMessage(error instanceof Error ? error.message : "Sayaç kurulamadı."); }
    finally { inFlight.current = false; setSaving(false); }
  };
return { lineId, setLineId, deviceId, setDeviceId, unit, setUnit, saving, message, save };
}
